import { render, staticRenderFns } from "./thirdStep.vue?vue&type=template&id=36acdc34&scoped=true"
import script from "./thirdStep.vue?vue&type=script&lang=js"
export * from "./thirdStep.vue?vue&type=script&lang=js"
import style0 from "./thirdStep.vue?vue&type=style&index=0&id=36acdc34&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acdc34",
  null
  
)

export default component.exports